import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  ShowButton,
  DateField,
  Filter,
  TextInput,
} from 'react-admin';
import { RepresentativeField } from './Fields';

const SolicitedUserFilters = props => (
  <Filter {...props}>
    <TextInput label="Name or Email" source="_OMNI_" alwaysOn />
    <TextInput label="First Name" source="_LIKE_firstName" />
    <TextInput label="Last Name" source="_LIKE_lastName" />
    <TextInput label="Email" source="_LIKE_email" />
  </Filter>
);

export default props => (
  <List
    {...props}
    title="Solicited Users"
    bulkActionButtons={false}
    sort={{ field: 'email', order: 'asc' }}
    filters={<SolicitedUserFilters />}
  >
    <Datagrid>
      <TextField source="email" />
      <TextField source="firstName" label="First Name" />
      <TextField source="lastName" label="Last Name" />
      <TextField source="status" />
      <DateField source="createdAt" label="Solicited at" />
      <ReferenceField label="Solicited By" source="solicitedBy" reference="users">
        <RepresentativeField />
      </ReferenceField>
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/SolicitedUsers/List.js